import moment from "moment";

Vue.filter("concat", (values, glue = ",") => {
    let s = "";
    values.forEach((value) => {
        if (s !== "") {
            s += glue + " ";
        }
        s += value;
    });
    return s;
});
/**
 * Format the given date.
 */
Vue.filter("date", (value) => {
    return moment.utc(value).local().format("MMM Do, YYYY");
});

/**
 * Format the given date.
 */
Vue.filter("birth_date", (value) => {
    return moment.utc(value).local().format("M/D/YYYY");
});

/**
 * Format the given date.
 */
Vue.filter("date_at", (value) => {
    if (!value) {
        return null;
    }
    return moment.utc(value).local().format("M/D/YY [at] hh:mm a");
});

/**
 * Format the given date.
 */
Vue.filter("month_year", (value) => {
    return moment.utc(value).local().format("MMMM YYYY");
});

Vue.filter("utc_from_now", function (value) {
    return moment.utc(value).fromNow();
});

/**
 * Format the given date as a timestamp.
 */
Vue.filter("datetime", (value) => {
    return moment.utc(value).local().format("MMM D, YYYY h:mma");
});

Vue.filter("short_datetime", (value) => {
    if (!value) {
        return null;
    }
    return moment.utc(value).local().format("MM/DD/YY h:mma");
});

Vue.filter("utc_time", (value) => {
    return moment.utc(value).format("hh:mm a");
});

Vue.filter("local_date", (value) => {
    return moment.utc(value).local().format("MMMM Do, YYYY");
});
Vue.filter("local_time", (value) => {
    return moment.utc(value).local().format("hh:mm a");
});

/**
 * Format the given date into a relative time.
 */
Vue.filter("relative", (value) => {
    /*moment.locale('en', {
        relativeTime : {
            future: "in %s",
            past:   "%s",
            s:  "1s",
            m:  "m",
            mm: "%dm",
            h:  "1h",
            hh: "%dh",
            d:  "1d",
            dd: "%dd",
            M:  "1m",
            MM: "%dm",
            y:  "1y",
            yy: "%dy"
        }
    });*/
    return moment.utc(value).local().fromNow();
});

Vue.filter("truncate", function (value, length) {
    if (!value) return;

    if (value.length < length) {
        return value;
    }

    length = length - 3;

    return value.substring(0, length) + "...";
});

Vue.filter("date_format", (value, format = "MM/DD/YYYY") => {
    return moment.utc(value).local().format(format);
});

Vue.filter("titleCase", function (str) {
    return str
        .split("_")
        .map(function (item) {
            return item.charAt(0).toUpperCase() + item.substring(1);
        })
        .join(" ");
});

/**
 * Convert the first character to upper case.
 *
 * Source: https://github.com/vuejs/vue/blob/1.0/src/filters/index.js#L37
 */
Vue.filter("capitalize", (value) => {
    if (!value && value !== 0) {
        return "";
    }

    return value.toString().charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("capitalize_all", (value) => {
    return value.replace(/\b\w/g, (l) => l.toUpperCase());
});

Vue.filter("lowercase", (value) => {
    if (!value && value !== 0) {
        return "";
    }
    return value.toString().toLowerCase();
});

Vue.filter("uppercase", (value) => {
    if (!value && value !== 0) {
        return "";
    }
    return value.toString().toUpperCase();
});

Vue.filter("currency", (value) => {
    let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });
    return formatter.format(value);
});

Vue.filter("florida_short_datetime", (value) => {
    if (!value) {
        return null;
    }
    return moment(value).format("MM/DD/YY h:mma");
    //return moment.utc(value).format('MM/DD/YY h:mma');
});
